import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { confService, authService } from '../../../Services';
import { apiUrl } from '../../../Services/config';

import Loader from '../../Common/Loader';
import {ReactComponent as Loading} from '../../../images/icons/General/loading-01.svg';

export const Page = () => {
    const params = useParams();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        const res = await confService.getPage(params.slug);
        if (res.page)
            setData(res.page);
        setLoading(false);
    }, [params]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            {loading ? <Loader /> : (
                data.id ? <>
                    <h1>{data.name}</h1>
                    <div className="page-content" dangerouslySetInnerHTML={{ __html: data.content }} />
                </> : <div className="error-404">There's nothing here: 404!</div>
            )}
        </>
    );
};

export default Page;
